module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    key: "relatedItem",
    staticClass: "modal-mask",
    attrs: {
      "id": "related-item"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper _modalWrapper_"
  }, [_c('div', {
    staticClass: "modal-container flexContainer"
  }, [_c('div', {
    staticClass: "modalBody"
  }, [_c('AddToBasket', {
    attrs: {
      "action": _vm.action
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btnCloseModalBasket"
  }, [_c('button', {
    staticClass: "btn uppercase",
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t("abonnement.close")))])])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e9c7997","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/ModalBasket.vue
// module id = 3136
// module chunks = 0